// extracted by mini-css-extract-plugin
export default {"whiteBoxWrapper":"whiteSection_whiteBoxWrapper__YTX7V"};